<template>
<div>
    <section >
        <div>
            <p class="mt-4 text-gray-400">{{display}}</p>
        </div>
        <div class="w-1/3 md:w-full" style="overflow:auto; height:20rem">
            <div @click="openChat(message)" v-for="message in messages" :key="message" class="cursor-pointer bg-gray-200 p-4 text-sm md:w-full  mt-8 rounded-xl float-left md:float-right">
                <div  class="flex">
                    <div>
                        <img src="../assets/customer-pic1.png" alt="pic">
                    </div>

                    <div class="ml-4 ">
                        <div class="flex justify-between">
                            <p class="text-blue-600">{{message.receiverName}}</p>
                            <p>{{moment(message.lastMessagePostedAt).format('LT ')}}</p>
                        </div>
                        <div>
                            <p>{{message.deliveryAddress[0]}}</p>
                        </div>
                        <p class="inline-block whitespace-nowrap overflow-hidden overflow-ellipsis w-60">
                            
                        </p>
                    </div>
                    <div>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isOpenChat" class=" w-1/3 md:w-full md:mr-0 mt-10 pb-8 bg-gray-100 absolute lg:relative top-20 right-6 rounded-2xl mr-10">
            <div class="w-4/5 m-auto pt-6">
                <div class="flex justify-between">
                    <div class="flex">
                        <img src="../assets/customer-pic1.png" alt="pic">
                        <div class="ml-4">
                            <p class="text-blue-700">{{haulageInfo.receiverName}}</p>
                            <p>{{haulageInfo.pickupAddress}}</p>
                        </div>
                    </div>
                    <div>
                        <!-- <p>{{moment(message.lastMessagePostedAt).format('hh:mma')}}</p> -->
                    </div>
                </div>

                <div class="bg-white p-6 mt-10 rounded-lg">
                    <p class="text-sm text-gray-500">Address of order</p>

                    <div class="flex mt-4">
                        <div>
                            <i class="fa fa-map-marker text-blue-600"></i>
                            <div class="ml-1">
                                <p>|</p>
                                <p>|</p>
                                <p>|</p>
                                <p>|</p>
                                
                            </div>
                            <div>
                                <i class="fa fa-map-marker text-gray-500"></i>
                            </div>
                        </div>

                        <div class="ml-4">
                            <p class="font-semibold">{{haulageInfo.pickupAddress}}</p>
                            <div>
                                <div class="flex mt-3">
                                    <i class="fa fa-user text-gray-500"></i>
                                    <p class="ml-2">{{haulageInfo.receiverName}} </p>
                                </div>

                                <div class="flex mt-3">
                                    <i class="fa fa-mobile text-gray-500"></i>
                                    <p class="ml-2">{{haulageInfo.receiverNumber}}</p>
                                </div>
                                <!-- <div class="flex mt-3">
                                    <i class="fa fa-comment text-gray-500"></i>
                                    <p class="ml-2">Hopefully we would like to received the order very soon</p>
                                </div> -->
                            </div>

                            <div class="mt-3 font-semibold">
                                <p>{{deliveryAddress}}</p>
                            </div>
                        </div>
                    </div>

                    
                </div>

                <!-- <div class="mt-6 p-6 pt-6 rounded-lg bg-white">
                    <p class="text-sm text-gray-500">Items to be delivered</p>
                    <p class="mt-2">
                        {{}}
                    </p>
                </div> -->

                <div class="mt-6 ">
                    <input class="w-full p-2 border rounded-lg" type="text" name="quotation" id="quotation" placeholder="Enter Quotation" v-model="quote">
                    <p class="text-red-500 text-xs" v-if="quoteValidity === 'invalid' ">enter quotation</p>
                    <div class="w-1/2 m-auto mt-6">
                        <button @click="sendQuote" class="rounded-xl bg-blue-800 text-white p-2">Send Quotation<i class="fa fa-spin fa-spinner" v-if="isLoading"></i></button>
                    </div>
                </div>


                <!-- <div class="flex justify-between mt-6 mb-6">
                    <div>
                        <i class="fa fa-check bg-blue-800 text-white p-3 rounded-full"></i>
                        <p>Accept</p>
                    </div>
                    <div>
                        <i class="fa fa-x bg-red-500 text-white p-3 rounded-full">X</i>
                        <p>Decline</p>
                    </div>
                    <div>
                        <i class="fa fa-phone bg-green-500 text-white p-3 rounded-full"></i>
                        <p>Contact</p>
                    </div>
                </div> -->
            </div>

            

            
        </div>
        
    </section>
    <SuccessfulModal
    v-show="successModal"
    @click="closeSuccessModal"/>
    <ErrorModal
     v-show="errorModal"
    @click="closeErrorModal"/>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import SuccessfulModal from '../../LandingPages/SuccessfulModal.vue';
import ErrorModal from '../ErrorModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        SuccessfulModal,
        ErrorModal
    },
    data() {
        return {
            adminMessage: [],
            messages : [],
            chats : [],
            customer: String,
            admin: String,
            sender: String,
            isOpenChat: false,
            theMessage : "",
            sendAdminMessage : [
                
            ],
            userId: localStorage.getItem('userId'),
            postMessage : "",
            orderId : this.$store.state.orderId,
            display : "",
            quote: "",
            quoteValidity:"",
            successModal: false,
            errorModal: false,
            isLoading: false,
            haulageInfo: [],
            deliveryAddress: "",
            
        }
    },

    mounted() {
        this.getMessages();
        this.networkError();
        this.getChat();
        this.sendMessage();
    },

    methods: {
        closeSuccessModal() {
            this.successModal = false;
        },
        closeErrorModal() {
            this.errorModal = false;
        },
        moment(date) {
            return moment(date)
        },
        getMessages() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/requests/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                response.json
                this.messages = response.data.data.results;
                this.admin = this.messages.customerId;
                if(this.messages.length <= 0) {
                    this.display = "You don't have any Haulage Requests."
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },

        openChat(message) {
             this.isOpenChat = true;
             this.customer = message.customerId
             this.sender = message.chatId
            this.$store.dispatch("orderId", message.orderId)
        this.getHaulageInfo();

        },

        getHaulageInfo() {
            let orderId = this.$store.state.orderId
            console.log(orderId);
            axios({
                method: 'GET',
                url: `${url}/v1/web/requests/info/${orderId}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                response.json
                this.haulageInfo = response.data.data;
                this.deliveryAddress = this.haulageInfo.deliveryAddress[0]
            })
            .catch((error) => {
                console.log(error)
            })
        },

       

        sendMessage() {
             var a = {
                "message":this.adminMessage
            }
            this.sendAdminMessage.push(a)
            for (let theMessage in this.sendAdminMessage) {
                this.postMessage = this.sendAdminMessage[theMessage].message
            }
            this.adminMessage = "";
            axios({
                method: 'post',
                url: `${url}/v1/web/chats/message/send`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    adminId : this.userId,
                    customerId: this.customer,
                    senderId: this.sender,
                    message: this.postMessage
                }
            })
            .then((response) => {
               response.json
            })
            .catch((error) => {
             console.log(this.adminMessage);
                console.log(error)
            })
        },

        getChat() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/chats/messages/${this.userId}?sortBy=name&limit=20&page=1&order=desc`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                response
                this.chats = response.data.data.results;
            })
            .catch((error) => {
                console.log(error)
            })
        },

        sendQuote() {
            let orderId = this.$store.state.orderId
            console.log(orderId);
            if(!this.quote) {
                this.quoteValidity = 'invalid';
            } else {
                this.isLoading = true;
                axios({
                    method: 'POST',
                    url: `${url}/v1/web/requests/quotation`,
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem("token"),
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        orderId : orderId,
                        quotation: this.quote
                    }
                    }) 
                    .then((res) => {
                        res
                        this.successModal = true;
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        err
                        this.errorModal = true;
                        this.isLoading = false;
                    })
            }
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>